import axios from 'axios';
import { API_URL ,GYPSYBALL_PYTHON_API_URL, GYPSYBALL_PYTHON_API_TOKEN } from 'configs'
import { isEmpty } from 'lodash';

export const WORKSPACE_FORM_REQUEST = 'WORKSPACE_FORM_REQUEST'
export const WORKSPACE_FORM_SUCCESS = 'WORKSPACE_FORM_SUCCESS'
export const WORKSPACE_FORM_VALIDATION_ERROR = 'WORKSPACE_FORM_VALIDATION_ERROR'
const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_WORKSPACE_FORM_FIELD_VALIDATION_ERROR = "HIDE_WORKSPACE_FORM_FIELD_VALIDATION_ERROR"
export const REDIRECT_TO_WORKSPACE_FORM_LIST = 'REDIRECT_TO_WORKSPACE_FORM_LIST'
export const WORKSPACE_FORM_GET_SUCCESS = 'WORKSPACE_FORM_GET_SUCCESS'
export const WORKSPACE_FORM_SERVER_SUCCESS = 'WORKSPACE_FORM_SERVER_SUCCESS'
const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER';

export const hardCodedWorkspaceNmae = 'clientoutcomesheet';

const showCommonLoader = (label = '') => ({
  type: SHOW_LOADER,
  common_loder_label: label
})
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
})

const workspaceFormRequest = () => ({
  type: WORKSPACE_FORM_REQUEST,
})

export const workspaceFormServerListForm = () => ({
  type: WORKSPACE_FORM_SERVER_SUCCESS,
})

const workspaceFormListSuccess = workspaceFormList => ({
  type: WORKSPACE_FORM_SUCCESS,
  workspaceFormList: workspaceFormList,
})



const workspaceFormFailure = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'general_error'
})
const validationError = notification => ({
  type: WORKSPACE_FORM_VALIDATION_ERROR,
  validation_error: notification,
})
const tokenError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'token_expire'
})

const workspaceFormAddUpdateSuccess = (message, action, dispatch) => {
  dispatch(workspaceFormSuccessNotification(message))
  dispatch(redirectToWorkspaceFormList())
}

export const redirectToWorkspaceFormList = () => ({
  type: REDIRECT_TO_WORKSPACE_FORM_LIST,
})

const getWorkspaceFormFormSuccess = (response, action) => ({
  type: WORKSPACE_FORM_GET_SUCCESS,
  record: response,
  actionType: action
})

const workspaceFormSuccessNotification = message => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: 'success'
})

export const hideWorkspaceFormValidationError = (feild_key) => ({
  type: HIDE_WORKSPACE_FORM_FIELD_VALIDATION_ERROR,
  feild_key: feild_key
})

export const workspaceFormListFetch = () => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(workspaceFormRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "workspace_form/getAll", {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
    })
      .then((response) => {
        dispatch(workspaceFormListSuccess(response.data))
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });

  }
}


export const addWorkspaceForm = (data) => {

  // return
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(workspaceFormRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "workspace_form/create", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: data,
    })
      .then((response) => {
        workspaceFormAddUpdateSuccess('Workspace Form Added Successfully', 'create', dispatch);
        //dispatch(getWorkspaceFormById(response.data.id, "update"));
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });

  }
}

export const updateWorkspaceForm = (data, id) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(workspaceFormRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "workspace_form/update/" + id, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer '+ token
      },
      data: data
    })
      .then((response) => {
        workspaceFormAddUpdateSuccess('Workspace Form Updated Successfully', 'update', dispatch)
        //dispatch(getWorkspaceFormById(id, "update"));
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });

  }
}

export const getWorkspaceFormById = (workspace_id, action) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(workspaceFormRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "workspace_form/getById/" + workspace_id, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer '+ token
      },
    })
      .then((response) => {
        dispatch(getWorkspaceFormFormSuccess(response.data, action))
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });

  }
}

export const deleteWorkspaceForm = (workspace_id, object_viewed_id = '') => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(workspaceFormRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "workspace_form/delete/" + workspace_id, {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: {
        object_viewed_id
      }
    })
      .then((response) => {
        dispatch(workspaceFormSuccessNotification('Workspace Form deleted successfully'))
        dispatch(workspaceFormListFetch())
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });
  }

}

//publish workspace form
export const publishWorkspaceForm = (id) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(workspaceFormRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "workspace_form/update/" + id, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer '+ token
      },
      data: {
        type: 'publishWorkspaceForm'
      }
    })
      .then((response) => {
        workspaceFormAddUpdateSuccess('Workspace Form Published Successfully', 'update', dispatch)
        // dispatch(getWorkspaceFormById(id, "update"));
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });

  }
}


export const clientOutcomeSheet = (data, id) => { alert('34');
 
  return dispatch => {
    dispatch(showCommonLoader());
    return axios(GYPSYBALL_PYTHON_API_URL+'upload/clientoutcomesheet', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
      },
      data: JSON.stringify(data)
    }).then(
      response => {
        dispatch(hideCommonLoader());

        if(!isEmpty(response.data.status)){ 
          dispatch(publishWorkspaceForm(id));
          //workspaceFormAddUpdateSuccess('Workspace Form Published Successfully', 'update', dispatch)
          // dispatch(workspaceFormSuccessNotification('Workspace Form published Successfully.'));
          
        }
       
        //return response;
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  }
}

export const deleteClientOutcomeSheet = (id, workspace = hardCodedWorkspaceNmae) => {
 
  return dispatch => {
    dispatch(showCommonLoader());
    return axios(GYPSYBALL_PYTHON_API_URL+'delete/clientoutcomesheetForm', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
      },
      data: {
        workspace_form_id: id,
        workspace: workspace
      }
    }).then(
      response => {
        dispatch(hideCommonLoader());

        if(!isEmpty(response.data.status)){
          dispatch(deleteWorkspaceForm(id));
          //dispatch(workspaceFormSuccessNotification('Workspace Form deleted Successfully.'));
          
        }
        
       
        //return response;
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  }
}

// handling error reponse   
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(validationError(error.response.data.error))
    }
    else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()))
    }
    else {
      let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString()
      }
      else {
        err = error.response.status + ` ` + error.response.statusText
      }
      dispatch(workspaceFormFailure(err))
    }
  }
  catch (e) {
    dispatch(workspaceFormFailure('Unable to perform action.Something went wrong'))
  }
}   